import { createSelector } from "reselect";

/**
 * selector to determine if patient overview pathways is enabled
 */
export const patientOverviewPathwaysEnabledSelector = createSelector(
  () => false
);
